import { Record, List } from 'immutable';

const defaultValues = {
  designThemeId: null,
  archivedMenuTital: null,
  archivedMenuStatus: false,
  recipeRefreshFlag: false,
  recipeRefreshCancelled: false,
  archiveDesignTitle: null,
  archiveDesignStatus: false,
  recipeAddToMenuStatus: false,
  recipeAddToMenuRecipeId: null,
  recipeToMenuCategoryId: null,
};

export default class GlobalParameter extends Record(defaultValues, GlobalParameter) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const GlobalParameters = (data) => {
  let globalParameters = new List();
  if (data) {
    data.forEach((value) => {
      globalParameters = globalParameters.push(new GlobalParameter(value));
    });
  }
  return globalParameters;
};
